import { render, staticRenderFns } from "./pushdown.vue?vue&type=template&id=2e016462&"
import script from "./pushdown.vue?vue&type=script&lang=js&"
export * from "./pushdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports